export default  {
    dateFormat: 'Y-m-d H:i:S',
    enableTime: true,
    enableSeconds: true,
    defaultHour: 0,
    defaultMinute: 0,
    defaultSecond: 0,
    mode: 'range',
    time_24hr: true,
    onClose: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        const startTime =  new Date(selectedDates[0]);
        const endTime = new Date(selectedDates[1]);
        endTime.setHours(23); // Set the default hour for end time
        endTime.setMinutes(59); // Set the default minute for end time
        endTime.setSeconds(59)
        instance.setDate([startTime,endTime], true);
      }
    },
}



